module.exports = __webpack_public_path__ + "img/waistband length.d4e829ee.png";